var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalP3Oil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1126 16.1191H6.6335L3.86146 40.973C3.81185 41.4148 3.85638 41.8621 3.99211 42.2857C4.12784 42.7093 4.3517 43.0992 4.64896 43.43C4.94701 43.7601 5.31166 44.0236 5.71886 44.2026C6.12606 44.3819 6.5666 44.4728 7.01148 44.4693H37.7556C38.2007 44.4728 38.6412 44.3819 39.0486 44.2026C39.4556 44.0236 39.8202 43.7601 40.1182 43.43C40.4155 43.0992 40.6394 42.7093 40.7753 42.2857C40.9109 41.8621 40.9555 41.4148 40.9058 40.973L39.3082 26.6495",
    stroke: "#FF5368",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5195 16.1255V11.4005C14.5195 9.31186 15.3492 7.30882 16.8261 5.83195C18.3029 4.35508 20.306 3.52539 22.3946 3.52539C24.4832 3.52539 26.4863 4.35508 27.9631 5.83195C29.44 7.30882 30.2697 9.31186 30.2697 11.4005V12.2126",
    stroke: "#FF5368",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3359 19.0404L30.2367 12.2148L37.2654 13.109L44.1475 23.4696L35.218 29.4011L28.3359 19.0404Z",
    stroke: "#FF5368",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalP3Oil);
export default __webpack_public_path__ + "static/media/Digital_P3_Oil.b87a68d27fd22711ea92befc52e14ab5.svg";
export { ForwardRef as ReactComponent };